"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerIconManager = void 0;
const constants_1 = require("./constants");
const utils_1 = require("./utils");
class MarkerIconManager {
    constructor(marker, meta, markers = []) {
        this.marker = marker;
        this.meta = meta;
        this.markers = markers;
        this._defaultDimensions = {
            w: 48,
            h: 48
        };
        // Initialize count from meta on construction
        this._defaultDimensions.count = meta.location.providerCount || 0;
    }
    attachListeners(markerElement) {
        this._setMarkerIconOnState(markerElement, constants_1.MarkerState.DEFAULT);
        this._attachMouseEvents(markerElement);
        this._attachKeyboardEvents(markerElement);
    }
    _attachKeyboardEvents(markerElement) {
        markerElement.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this._unSelectPreviousSelectedMarker();
                this.meta.isClicked = true;
                this.setIcon({ marker: this.marker, meta: this.meta });
            }
        });
        // Focus events
        markerElement.addEventListener('focus', () => {
            this.meta.isHovered = true;
            this.setIcon({ marker: this.marker, meta: this.meta });
        });
        markerElement.addEventListener('blur', () => {
            this.meta.isHovered = false;
            this.setIcon({ marker: this.marker, meta: this.meta });
        });
    }
    _unSelectPreviousSelectedMarker() {
        const previousSelectedMarker = this.markers.filter(({ meta }) => meta.isClicked);
        previousSelectedMarker.forEach(({ marker, meta }) => {
            meta.isClicked = false;
            this.setIcon({ marker, meta });
        });
    }
    _attachMouseEvents(markerElement) {
        markerElement.addEventListener('mouseenter', () => {
            this.meta.isHovered = true;
            this.setIcon({ marker: this.marker, meta: this.meta });
        });
        markerElement.addEventListener('mouseleave', () => {
            this.meta.isHovered = false;
            this.setIcon({ marker: this.marker, meta: this.meta });
        });
        markerElement.addEventListener('mousedown', () => {
            this._unSelectPreviousSelectedMarker();
            this.meta.isClicked = true;
            this.setIcon({ marker: this.marker, meta: this.meta });
        });
    }
    removeListeners(markerElement) {
        markerElement.replaceWith(markerElement.cloneNode(true));
    }
    _setMarkerIconOnState(markerElement, state) {
        const iconDataUrl = (0, utils_1.getMarkerIconForState)(state, this._defaultDimensions);
        markerElement.src = iconDataUrl;
        if (state === constants_1.MarkerState.PRESSED) {
            markerElement.setAttribute('aria-pressed', 'true');
        }
        else {
            markerElement.setAttribute('aria-pressed', 'false');
        }
        markerElement.style.zIndex = (state === constants_1.MarkerState.FOCUSED || state === constants_1.MarkerState.HOVERED ? 1000 : 1).toString();
    }
    setIcon({ marker, meta }) {
        const target = marker.getElement();
        this._defaultDimensions.count = meta.location.providerCount || 0;
        if (meta.isClicked) {
            return this._setMarkerIconOnState(target, constants_1.MarkerState.FOCUSED);
        }
        if (meta.isHovered) {
            return this._setMarkerIconOnState(target, constants_1.MarkerState.HOVERED);
        }
        return this._setMarkerIconOnState(target, constants_1.MarkerState.DEFAULT);
    }
}
exports.MarkerIconManager = MarkerIconManager;
//# sourceMappingURL=markerStatesManager.js.map